import { render, staticRenderFns } from "./FieldsetRegisterEntry.yaml?vue&type=template&id=037535a9&component"
import script from "./FieldsetRegisterEntry.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetRegisterEntry.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports